import { animate, AnimationStyleMetadata, transition, trigger } from '@angular/animations';

export const flyInOut = (inactiveStyle: AnimationStyleMetadata, timing: string) =>
  trigger('flyInOut', [
    transition('void => *', [inactiveStyle, animate(timing)]),
    transition('* => void', [animate(timing, inactiveStyle)]),
  ]);
